/** Orders > Import from PDF. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { OrderImportPage } from "@/features/sales-dispatch/components/order-import-page";

export const Route = createFileRoute("/_app/orders/import")({
  beforeLoad: () => {
    if (!useAuth.getState().can("orders.book"))
      throw redirect({ to: "/orders" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return <OrderImportPage facilityId={selected?.id} />;
}
